/**
 * Find Decision Makers manifest — `find-decision-makers` action.
 *
 * Walks any source → company. Opens the existing FindDecisionMakersModal
 * with the resolved company prefilled.
 *
 * For deals: walks deal → company (auto-resolved, one hop).
 * For contacts: walks contact → company.
 */

import { MODAL_IDS } from "@wtc/ui";

import { registerActionManifest } from "./registry";

registerActionManifest({
  actionId: "find-decision-makers",
  label: "Find decision makers",
  primaryEntity: "company",
  requires: {
    entity: "company",
    requiredFields: [],
  },
  mode: "client-redirect",
  clientRun: (resolved, hooks) => {
    hooks.openModal(MODAL_IDS.companies.findDecisionMakers, {
      companyId: resolved.targetIds[0],
      sourceEntity: resolved.sourceEntity,
      sourceId: resolved.sourceId,
    });
  },
});
